<app-dialog-header
	variant="info"
	(closeClick)="close()"
></app-dialog-header>
<mat-dialog-content class="center-block">
	@if (data.errorCode == "1") {
		<p [innerHTML]="'privacy-policy.html-full' | translate | safeHtml"></p>
	}
	@if (data.errorCode == "2") {
		<p [innerHTML]="'termini-condizioni.html-full' | translate | safeHtml"></p>
	}
</mat-dialog-content>